import {addProductToCart, voucherProductAddToCartGt2} from "../../helper/VoucherProductHelper";
import {voucherValidationHelper} from "../../helper/VoucherValidationHelper";
import {getCategoriesByShopId} from "../../libraries/utils";
import {pushGTMInternal} from "../../integrations/tracking/gtm/pushGtmEvents";
import {SET_VOUCHER_PRODUCT_ADD_TO_CART} from "../../store/mutation-types";

export default {
	methods: {
		async takeAward(productId, voucherId) {
			const self = this;
			const ids = self.userVouchers.map(x=>x.voucherId).concat(this.$store.getters.vouchersRedeemed || []);
			const psWithVouchers = self.cartProducts.filter(x=>x.voucherId);
			if (psWithVouchers.find(x => ids.includes(x.voucherId))) {
				self.$store.commit("SET_GLOBAL_INFO_DIALOG", "utilityComponents.productAsCompensationCRMModule.onlyOneAppliedDiscountAllowed");
				return;
			}
			if(productId) {
				self.$store.commit(SET_VOUCHER_PRODUCT_ADD_TO_CART, {productId, voucherId: voucherId});
			}
			if(self.isMobile) {
				const isShopAvailable = !!this.$store.getters.globalSelectedShop;
				if(isShopAvailable) {
					if(productId) {
						await addProductToCart(self, productId, voucherId);
					}
					const res = await voucherValidationHelper(self, voucherId);
					if(!res.success) {
						self.$store.commit(SET_VOUCHER_PRODUCT_ADD_TO_CART, null);
						if(res.messageKey) {
							this.$store.commit("SET_GLOBAL_INFO_DIALOG", res.messageKey);
						}
						return;
					}
				}
				await voucherProductAddToCartGt2(self, !isShopAvailable);
			} else {
				if (self.featureToggles.newBasketPage && ((self.globalSelectedShop || {}).shopOptions || {}).enableNewBasketPage) {
					if (self.$route.path.includes("basket")) {
						if(productId) {
							await addProductToCart(self, productId, voucherId);
						}
						await voucherValidationHelper(self, voucherId);
					} else {
						if (self.globalSelectedShop && self.productCatalog) {
							if(productId) {
								await addProductToCart(self, productId, voucherId);
							}
							await voucherValidationHelper(self, voucherId);
							self.$router.push(`/basket`);
						} else {
							self.$router.push(`/shop-selection`);
						}
					}
				} else {
					if (self.$route.path.includes("category")) {
						if(productId) {
							await addProductToCart(self, productId, voucherId);
						}
						await voucherValidationHelper(self, voucherId);
					} else {
						if (self.globalSelectedShop && self.productCatalog) {
							const categories = getCategoriesByShopId(self.globalSelectedShop.id, self.productCatalog);
							self.$router.push(`/category/${categories[0].extId}`);
						} else {
							self.$router.push(`/shop-selection`);
						}
					}
				}
			}
			if(self.featureToggles.showAvailableVouchersInBasket) {
				pushGTMInternal(
					"voucher_redeemed",
					this.$route.name,
					this.$route.path,
					"carousel_vouchers"
				);
			}
			self.onClose && self.onClose();
		}
	}
};